import * as React from 'react'

export interface PDFReportHeaderField {
  label: string
  value: string | number
  condition?: boolean
}

export interface PDFReportHeaderProps {
  title: string
  dateRange?: string
  dateRangeLabel?: string
  reportGenerated?: string
  fields: PDFReportHeaderField[]
  analysis?: string
}

export const PDFReportHeader: React.FC<PDFReportHeaderProps> = ({
  title,
  dateRange,
  dateRangeLabel,
  reportGenerated = new Date().toLocaleString(),
  fields,
  analysis
}) => {
  const getDateRangeDisplay = (): string => {
    if (dateRangeLabel && dateRangeLabel !== 'Custom Date Range') {
      return dateRangeLabel
    }
    return dateRange || ''
  }

  return (
    <div className="pdf-report-header">
      <h1 className="pdf-report-title">{title}</h1>
      <div className="pdf-report-summary">
        <h3>Report Summary</h3>
        {dateRange && <p><strong>Date Range:</strong> {getDateRangeDisplay()}</p>}
        <p><strong>Report Generated:</strong> {reportGenerated}</p>
        {fields.map((field, index) => 
          (field.condition === undefined || field.condition) && (
            <p key={`${field.label}-${index}`}>
              <strong>{field.label}:</strong> {field.value}
            </p>
          )
        )}
        {analysis && <p><strong>Analysis:</strong> {analysis}</p>}
      </div>
    </div>
  )
}